<template>
  <fragment>
	<common-header
			name="문자 양식 관리"
			subname="문자 관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:searchbox="searchbox"
			@keywordChanged="keywordChanged"
		></common-header>

	<section class="container">
			<ctrl-filter listName="문자 양식 목록" @changeFilters="changeFilters"></ctrl-filter>

			<div class="container-fiuld">
				<div class="btn-group-box clearfix">
					<div class="btn-group pull-left clearfix">
						<div class="select pull-left m-r-5">
							<a class="btn btn-red round" @click="removeAllItem">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="17" height="20" viewBox="0 0 17 20">
									<path class="recycle"
										d="M510.213,1255.71h1.574v8.16h-1.574v-8.16Zm3.148,0h1.574v8.16h-1.574v-8.16Zm-6.3,0h1.574v8.16h-1.574v-8.16Zm10.074-5.86h-2.4v-0.51a2.353,2.353,0,0,0-2.361-2.34h-2.755a2.354,2.354,0,0,0-2.361,2.34v0.51h-2.4a2.353,2.353,0,0,0-2.361,2.34v1.96h1.574v10.51a2.353,2.353,0,0,0,2.361,2.34h9.13a2.353,2.353,0,0,0,2.361-2.34v-10.51H519.5v-1.96A2.353,2.353,0,0,0,517.139,1249.85Zm-8.3-.51a0.784,0.784,0,0,1,.787-0.78h2.755a0.784,0.784,0,0,1,.787.78v0.51h-4.329v-0.51Zm7.517,15.32a0.784,0.784,0,0,1-.787.78h-9.13a0.784,0.784,0,0,1-.787-0.78v-10.51h10.7v10.51Zm1.574-12.07H504.074v-0.4a0.784,0.784,0,0,1,.787-0.78h12.278a0.784,0.784,0,0,1,.787.78v0.4Z"
										transform="translate(-502.5 -1247)" />
								</svg> 삭제
							</a>
						</div>
					</div>

					<div class="btn-group pull-right clearfix">
						<select  v-model="pageSize" @change="setPageSize()" class="form-control round pull-left m-r-5">
							<option value="10">10개씩 보기</option>
							<option value="30">30개씩 보기</option>
							<option value="50">50개씩 보기</option>
						</select>
						<select  v-model="orderBy" @change="setPageSizeOrder()"  class="form-control round pull-left m-r-5">
							<option value="A.REG_DATE DESC">작성일 최신순</option>
							<option value="A.REG_DATE ASC">작성일 과거순</option>
						</select>
					</div>
				</div>
				<table class="table2 table-hover m-t-10 text-center">
					<thead>
						<tr>
							<th>
								<input @click="allChecked" v-model="checked_all"
										id="table-allcheck" class="checkbox" type="checkbox">
								<label for="table-allcheck">체크버튼</label>
							</th>
							<th>내용</th>
							<th>작성자</th>
							<th>작성일</th>
							<th>공유설정</th>
							<th>관리</th>
						</tr>
					</thead>
					<tbody v-for="(sms_item, index) in sms_templ_list" :key="index">
						<tr class="margin">
							<td colspan="7"></td>
						</tr>
						<tr>
							<td>
								<input
									type="checkbox"
									:id="'smsItem-'+sms_item.smsTemplId"
									:value="sms_item.smsTemplId"
									v-model="checked_item"
									class="checkbox"
								>
								<label :for="'smsItem-'+sms_item.smsTemplId">체크버튼</label>
							</td>
							<td class="text-left" @click="getSmsForm(sms_item)">
								<!-- 상세보기 -->
								<a>{{ sms_item.content | parseContent }} </a>
							</td>
							<td>
								{{ sms_item.mberId }}
							</td>
							<td>
								{{ sms_item.regDate | parseRegDate }}
							</td>
							<td>
								{{sms_item.shareEnable == 0 ? '나만보기' : '공유하기'}}
							</td>
							<td>
								<a class="del" @click="removeModal(sms_item.smsTemplId)">삭제</a>
							</td>
						</tr>
					</tbody>
				</table>

				<ctrl-pagination :currentPage="offset / pageSize + 1"
					:pageSize="parseInt(pageSize)" :totalCount="totalCount"
					:key="hash({pageSize, offset, totalCount})"
					@pageChanged="onPageChanged"></ctrl-pagination>
			</div>
		</section>
		<common-footer></common-footer>
		<ModalSmsFormRegister
			:config="modals.ModalSmsFormRegister"
			:key="'ModalSmsFormRegister-'+hash(modals.ModalSmsFormRegister)"
			@close="modals.ModalSmsFormRegister.show=false;"
			@refresh="refreshData()"
		></ModalSmsFormRegister>
		<ModalSmsForm
			:config="modals.ModalSmsForm"
			:key="'ModalSmsForm-'+hash(modals.ModalSmsForm)"
			@close="modals.ModalSmsForm.show=false;"
			@refresh="refreshData()"
		></ModalSmsForm>
		<modal-confirm
			:config="modals.ModalConfirm"
			@yes="removeCancleItem()"
			@no="removeItem()"
			:key="hash(modals.ModalConfirm)"
		></modal-confirm>
  </fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CtrlPagination from '../components/CtrlPagination.vue'
import CtrlFilter from '../components/CtrlFilter.vue'

import ModalSmsFormRegister from '../modals/ModalSmsFormRegister'
import ModalSmsForm from '../modals/ModalSmsForm'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import server from '../statics/server'
import _ from 'lodash'
import moment from 'moment'

export default {
	name:"ViewSmsFormList",
	mixins: [fnAdjustHeight],

	components:{
		CommonHeader,
		CommonFooter,
		CtrlFilter,
		CtrlPagination,

		ModalSmsFormRegister,
		ModalSmsForm,
		ModalConfirm,
		/* eslint-disable vue/no-unused-components */
		ModalAlert

	},
	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'문자 양식 관리',link:"/sms/forms",selected:true},
				{name:'보낸 문자함',link:"/sms/sents",selected:false}
			],
			buttons: [ // 헤더버튼
				{name:'새 양식 작성',fn:this.onNewForm},
			],
			smss: [], // 받은 문자들
			mainmenuOpened: true,
			searchbox: true,

			init_list : [
				{db_name : 'sys/smsTempl', list_name :'sms_templ_list'},
			],

			modals : {
				ModalSmsFormRegister : ModalSmsFormRegister.default(),
				ModalSmsForm : ModalSmsForm.default(),
				ModalAlert: ModalAlert.default(),
				ModalConfirm: ModalConfirm.default(),
			},

			sms_templ_list : [],

			remove_sms_item : '',

			share_list : [],

			checked_item : [],
			checked_all : false,

			mberId : 'test', // 임시 사용자 아이디

			// 정렬
			totalCount : 0,
			offset : 0,
			keyword : '',
			pageSize : 10,
			orderBy : "A.REG_DATE DESC",
			filterList : ''
		}
	},
	mounted(){
		//this.getList(this.init_list[0].db_name, this.init_list[0].list_name, {});
		this.setPageSizeOrder();
	},
	filters: {
		parseRegDate(date){
			return moment(date).format('YYYY-MM-DD')
		},
		parseContent(val){
			return val.length > 30 ? val.slice(0, 30) + '...' : val
		}
	},
	methods: {
		keywordChanged(keyword){
			this.keyword = keyword;
			this.setPageSizeOrder();
		},
		onPageChanged(page){
			this.offset = (page - 1) * this.pageSize;
			this.setPageSizeOrder();
		},
		changeFilters(filter_list){
			this.filter_list = filter_list;
			this.setPageSizeOrder();
		},
		setPageSize(){
			this.offset = '0';
			this.setPageSizeOrder();
		},
		setPageSizeOrder(){
			let config_option = {
				parentsId : '0',
				keyword : this.keyword,
				offset : this.offset.toString(),
				pageSize : this.pageSize,
				orderBy : this.orderBy,
				filterList : this.filter_list
			}
			config_option = _.pickBy(config_option);
			this.getList(this.init_list[0].db_name, this.init_list[0].list_name, config_option);
		},

		refreshData(){
			this.getList(this.init_list[0].db_name, this.init_list[0].list_name, {});
		},
		allChecked(){
			const self = this;
            if (this.checked_all) {
				this.checked_item = [];
            }else{
				this.checked_item = _.map(self.sms_templ_list, 'smsTemplId');
			}
			this.checked_all = !this.checked_all;
		},
		getSmsForm(sms_item){
			this.modals.ModalSmsForm.item = sms_item;
			this.modals.ModalSmsForm.show = true;
		},
		getList (db_name, list_name, config_option){
			// select_name : 선택 분류, parentsId_val : 검색할 카테고리 아이디 list_name : 갱신 할 리스트 명
			const self = this;
			let config = config_option || {}
			server.postAxios(db_name, config, ({data , err}) => {
				err;
				if(list_name == 'sms_templ_list'){
					self.totalCount = parseInt(data.filtered)
				}
				self[list_name] = data.list || self.dummyData
			});
		},
		onNewForm: function() {
			this.modals.ModalSmsFormRegister.show = true;
		},
		removeAllItem: function() {
			this.modals.ModalConfirm.msg = "문자 양식을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "취소";
			this.modals.ModalConfirm.btnNo.name = "삭제";
			this.modals.ModalConfirm.show = true;
		},
		removeModal: function(smsTemplId) {
			this.remove_sms_item = smsTemplId;
			this.modals.ModalConfirm.msg = "문자 양식을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "취소";
			this.modals.ModalConfirm.btnNo.name = "삭제";
			this.modals.ModalConfirm.show = true;
		},
		removeItem(){
			const self = this;
			this.modals.ModalConfirm.show = false;
			if(this.remove_sms_item == ''){
				let removeItems = [];
				_.forEach(self.checked_item, (id) => {
					removeItems.push({smsTemplId : id});
				});
				server.deleteListAxios('sys/smsTempl', removeItems, ({data , err}) => {
					err; data;
					self.getList(self.init_list[0].db_name, self.init_list[0].list_name, {});
					self.refreshData();
				});
			}else{
				server.deleteAxios('sys/smsTempl', {id :this.remove_sms_item}, ({data , err}) => {
					err; data;
					self.remove_sms_item == '';
					self.getList(self.init_list[0].db_name, self.init_list[0].list_name, {});
					self.refreshData();
				});
			}
		},
		removeCancleItem(){
			this.modals.ModalConfirm.show = false;
			this.remove_survey_item = '';
		},
	}

}
</script>

<style scoped>
.recycle {
	fill: #fff;
	fill-rule: evenodd;
}
</style>